function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
Object.defineProperty(exports, "ButtonProps", {
  enumerable: true,
  get: function get() {
    return _props.ButtonProps;
  }
});
Object.defineProperty(exports, "ButtonSize", {
  enumerable: true,
  get: function get() {
    return _props.ButtonSize;
  }
});
Object.defineProperty(exports, "ButtonType", {
  enumerable: true,
  get: function get() {
    return _props.ButtonType;
  }
});
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
require("core-js/features/url");
require("core-js/features/url-search-params");
var _Container = require("./Container");
var _Label = require("./Label");
var _props = require("./props");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["fullWidth", "testID", "containerStyle", "children", "containerRef"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var Component = (0, _react.forwardRef)(function (_ref, ref) {
  var fullWidth = _ref.fullWidth,
    testID = _ref.testID,
    containerStyle = _ref.containerStyle,
    children = _ref.children,
    containerRef = _ref.containerRef,
    attrs = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return (0, _jsxRuntime.jsx)(_Container.Container, {
    ref: containerRef,
    fullWidth: fullWidth,
    testID: testID,
    containerStyle: containerStyle,
    isFake: attrs.isFake,
    children: (0, _jsxRuntime.jsx)(_Label.Label, Object.assign({}, attrs, {
      ref: ref,
      children: children
    }))
  });
});
var Button = exports.Button = (0, _react.memo)(Component);